<template>
  <iframe style="height: 100%" :src="'/static/pdfjs-3.2.146-dist/web/viewer.html?file=' + newUrl"/>
</template>

<script>

export default {
  name: "FileView",
  props: {
    url: {
      type: String
    }
  },
  data() {
    return {
      show: {
        // 预览pdf
        previewPdfDialog: false,
      },
    }
  },
  computed: {
    newUrl() {
      let currentUrl = window.location.protocol +'//'+ window.location.host
      const index = this.url.indexOf('fileServer');
      if (index !== -1) {
        return currentUrl + '/' + this.url.substring(index);
      }else {
        return this.url // 如果没有找到目标单词，返回原始字符串
      }
    }
  },
  methods: {
    previewPDF() {
    },
  },
}
</script>

<style scoped>

</style>